import React, { useContext } from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Button from "nx-components/Button";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButtonGroup from "nexia_mobile/components/Controls/DeviceControlButtonGroup";
import IconFromServer from "nexia_mobile/components/IconFromServer";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

const ActionButtons = ({ model, isDetailed, showSpinner, hideSpinner }) => {
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.controls.ActionButtons;
  let actions = model.get("actions");
  let buttons = Object.entries(actions).map(([key, action]) => {
    const actionString = languageContext.template(
      language.tellingActionTemplate,
      { name: model.get("name"), action: action.button_text }
    );
    return (
      <Button
        key={key}
        onTap={() => {
          showSpinner(actionString);
          model.performAction(action).then(hideSpinner, hideSpinner);
        }}
        disabled={action.disabled}
      >
        {action.icon ? <IconFromServer value={action.icon} /> : null}
        {action.icon && action.button_text ? (
          <span style={{ marginRight: "0.25em" }} />
        ) : null}
        {action.button_text}
      </Button>
    );
  });

  return (
    <CommonControlWrapper isDetailed={isDetailed}>
      <DeviceControlButtonGroup>{buttons}</DeviceControlButtonGroup>
    </CommonControlWrapper>
  );
};

ActionButtons.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/components/Controls/ActionButtons.jsx